import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { handleLogout } from 'redux/reducers/auth';
import './index.scss';
import ArrowIcon from 'assets/images/icons/arrow.png';
import { connect } from 'react-redux';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ROUTES } from 'config/constants';

export class Header extends Component {
    state = {
        showMenu: false
    }

    mockProfilePhoto = 'https://images.generated.photos/O_uLFuL-arsjLClgRePdbtMBuYFjfknayJR6Yj6FGQw/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzAzMzcxOTguanBn.jpg';

    onClickProfile = () => {
        const { history } = this.props;

        this.toggleMenu();
        history.push(ROUTES.PROFILE);
    }

    toggleMenu = () => this.setState(state => ({ showMenu: !state.showMenu }));

    stopPropagation = (event) => {
        event.stopPropagation();
    }

    render() {
        const { showMenu } = this.state;
        const { profile: { name, avatar }, handleLogout } = this.props;

        return (
            <div className='Header'>
                <span className='Header__name'>{name}</span>
                {avatar ? <img src={avatar} className='Header__photo' alt='Profile' /> : <FontAwesomeIcon icon={faUser} size={'1x'} />}
                <div className='Header__arrow' onClick={() => this.toggleMenu()}>
                    <img src={ArrowIcon} className='Header__arrow_img' alt='open' />
                </div>
                {showMenu ? <div className='Header__menu' onClick={this.stopPropagation}>
                    <div className='Header__menu_inner' />
                    <div className='Header__menu_items'>
                        <span className='Header__menu_items_item' onClick={this.onClickProfile} >Profile</span>
                        <span className='Header__menu_items_item' onClick={handleLogout} >Log out</span>
                    </div>
                </div> : null}
                {showMenu && <div className='Header__backdrop' onClick={this.toggleMenu} />}
            </div>
        );
    }
}

Header.propTypes = {
    profile: PropTypes.object.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    handleLogout: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        profile: state.auth.profile
    };
};

const mapDispatchToProps = dispatch => {
    return {
        handleLogout: () => dispatch(handleLogout(true))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
